import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import ThreatEdit from "@/pages/ThreatEdit";
export const Route = createFileRoute("/threat-builder/$id")({ head: ({match}) => pageHead(match.pathname), component: () => (<ProtectedRoute><ThreatEdit /></ProtectedRoute>) });
